import { PHONE_SEPARATOR } from '@gig/magic-common';
import { getCountries } from '@gig/magic-corex';
import { configQuery } from '@gig/magic-common';
import { ICountry } from '@gig/magic-sdk/dist/adapter/users/getCountries';
import {
    IUpdateUserProfileParams,
    IUserProfile,
} from '@gig/magic-sdk/dist/adapter/users/user';
import { USER_PROFILE_DATA } from '@gig/magic-messages';
import { config } from '../../';

export async function areUserDetailsMissing(): Promise<boolean> {
    const userDetails = await getUserDetails();
    return userDetails.some(([field, value]) => !isFieldFilledIn(field, value));
}

export async function getUserDetails(): Promise<Array<[string, any]>> {
    const { user } = await getUserProfile();
    const {
        mobileNumber: { number, prefix },
        address,
    } = user;

    const [customCountries, defaultCountries] = await Promise.all([
        configQuery<ICountry[]>('countries.customCountries'),
        getCountries(),
    ]);

    const country = (
        customCountries?.length ? customCountries : defaultCountries.countries
    ).find(({ code }) => code === address.addressCountry);

    return [
        ['firstName', user.givenName],
        ['lastName', user.familyName],
        ['address', address.streetAddress],
        ['city', address.addressLocality],
        config.sweepstakes
            ? ['state', address.addressRegion]
            : ['country', address.addressCountry],
        ['postcode', address.postalCode],
        [
            'dob',
            // yyyy-mm-dd
            user.birthDate &&
                new Date(user.birthDate).toISOString().split('T')[0],
        ],
        [
            'phone',
            prefix
                ? [prefix || '', number || ''].join(PHONE_SEPARATOR)
                : number
                ? [country?.phonePrefix || '', number || ''].join(
                      PHONE_SEPARATOR,
                  )
                : country?.phonePrefix,
        ],
    ];
}

export async function getUserUpdateParams(
    formValue: any,
): Promise<IUpdateUserProfileParams> {
    const profile = await getUserProfile();
    return {
        user: {
            ...profile.user,
            givenName: formValue.givenName,
            familyName: formValue.familyName,
            birthDate: new Date(formValue.birthDate).toISOString(),
            address: {
                ...profile.user.address,
                addressCountry: formValue.addrCountryCode,
                addressLocality: formValue.addrLocality,
                addressRegion: formValue.addressRegion,
                postalCode: formValue.addrPostalCode,
                streetAddress: formValue.addrStreetAddress,
            },
            mobileNumber: {
                prefix: formValue.mobilePrefix,
                number: formValue.mobileNumber,
            },
        },
    };
}

function isFieldFilledIn(field: string, value: any): boolean {
    if (field === 'phone') {
        return isPhoneFilledIn(value);
    } else {
        return !!value;
    }
}

function isPhoneFilledIn(value: string) {
    return value ? value.trim().split(PHONE_SEPARATOR).length > 1 : false;
}

function getUserProfile() {
    return window.queryBus.query<IUserProfile>(USER_PROFILE_DATA);
}
